import React from 'react';
import { Popper, PopperProps } from '@material-ui/core';
import { PopperExpandedInlineStyles } from './styles';

const PopperExpanded = (props: PopperProps) => {
  return <Popper {...props} style={PopperExpandedInlineStyles} placement="bottom-end" />;
};

export default PopperExpanded;
